<template>
  <span class="input-with-errors">
    <input
      :id="htmlId"
      v-model="valueHandler"
      v-validate.initial
      type="text"
      class="asd-input"
      :class="['asd-input--' + fieldsClasses[id]]"
      :required="valueRequired"
      :pattern="valuePattern"
      :name="id"
      :autocomplete="htmlId"
      :disabled="isDisabled"
      data-vv-as=" "
      @blur="blur"
    />
    <FormErrors
      v-if="fieldsClasses[id] !== 'pristine'"
      :id="id"
      :errorsObject="errors"
      :propertyType="propertyType"
    >
    </FormErrors>
  </span>
</template>

<script>
import FormErrors from 'CORE/components/form/errors'
import DataTypeMixin from 'CORE/mixins/dataType'
import _ from 'lodash'
import { createDataTypeValue } from '../utils'

export default {
    name: 'UrlInput',
    components: {
        FormErrors,
    },
    mixins: [
        DataTypeMixin,
    ],
    computed: {
        valueHandler: {
            get() {
                return _.get(this, 'value.value.value', '')
            },
            set(value) {
                if (_.size(value) === 0) {
                    this.$emit('delete')
                } else {
                    this.$emit('input', createDataTypeValue(value))
                }
            },
        },
        valueRequired() {
            return _.get(this.propertyType, 'settings.validation.required', false)
        },
        valuePattern() {
            const pattern = _.get(this.propertyType, 'settings.validation.pattern', '')
            if (_.size(pattern) > 0) {
                return pattern
            }
            return false
        },
        fieldsClasses() {
            return _.mapValues(this.fields, value => {
                if (_.get(value, 'touched')) {
                    if (_.get(value, 'valid')) return 'valid'
                    if (_.get(value, 'invalid')) return 'invalid'
                }
                if (_.get(value, 'pristine')) return 'pristine'
            })
        },
        isDisabled() {
            if (_.isString(_.get(this.lock, 'user')) && (_.get(this.lock, 'user') !== _.get(this.$store.getters.currentUser, 'id'))) {
                return true
            }
            return _.get(this.propertyType, 'settings.default_value.enabled', false)
        },
    },
    mounted() {
        const labelOptions = []
        if (_.get(this.propertyType, 'settings.default_value.enabled', false)) {
            if (this.value === null) {
                this.valueHandler = null
            }
            labelOptions.push('server-calculated')
        }
        if (_.get(this.propertyType, 'settings.validation.required', false)) {
            labelOptions.push('required')
        }
        this.$emit('labelOptions', labelOptions)
    },
    methods: {
        blur() {
            this.$emit('blur')
        },
    },
}
</script>
